export default {
    manageAttendance: 'Manage Attendance',
    searchByEmployeeName: 'Search by Employee Name',
    search: 'Search',
    employeeName: 'Employee Name',
    group: 'Group',
    department: 'Department',
    date: 'Date',
    checkIn: 'Check-In',
    status: 'Status',
    action: 'Action',
    congratulation: 'Congratulation'
}
